import React from 'react';
import { Link } from 'react-router-dom';
import { CAMPAIGN_TOOLS } from '../../data/campaign';

export default function CampaignDiscovery() {
  if (!CAMPAIGN_TOOLS.length) return null;
  return <section className="content-narrow py-10" data-campaign-discovery>
    <h2 className="section-title">More copy-and-paste text tools</h2>
    <p className="text-slate-600 my-3">Choose a focused tool for a particular style, alphabet or symbol.</p>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">{CAMPAIGN_TOOLS.map(tool =>
      <Link key={tool.path} to={tool.path} className="editorial-card p-5 block hover:border-[var(--brand)]">
        <h3 className="text-lg text-[var(--brand)] font-semibold">{tool.title}</h3>
        <p className="text-sm text-slate-600 mt-2">{tool.description}</p>
      </Link>)}</div>
  </section>;
}
